var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 5c-1.568 0-2.94 1.397-2.94 3.25S10.432 11.5 12 11.5c1.568 0 2.94-1.397 2.94-3.25S13.568 5 12 5ZM7.56 8.25C7.56 5.685 9.492 3.5 12 3.5c2.508 0 4.44 2.185 4.44 4.75S14.508 13 12 13c-2.508 0-4.44-2.185-4.44-4.75Zm-2.257 8.64c-.646.547-1.053 1.338-1.053 2.36v1.25h15.5v-1.25c0-1.022-.407-1.813-1.053-2.36C18.04 16.335 17.095 16 16 16h-3.25v2.25a.75.75 0 0 1-1.5 0V16H8c-1.095 0-2.04.334-2.697.89Zm-.97-1.144C5.306 14.924 6.61 14.5 8 14.5h8c1.39 0 2.695.424 3.666 1.246.983.832 1.584 2.041 1.584 3.504v1.5A1.25 1.25 0 0 1 20 22H4a1.25 1.25 0 0 1-1.25-1.25v-1.5c0-1.463.6-2.672 1.584-3.504Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/人事管理.34d48bc4c750892156cf8aa99836c403.svg";
export { ForwardRef as ReactComponent };